export default function reportsList() {
  return [
    {
      "id": "missingPreferredLabels",
      "category": "Preferred Labels",
      "title": {
        "en": "Concepts Missing Preferred Labels"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "List any concepts that do not have preferred labels in all project languages."
      },
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>
SELECT ?Concept ?Default_Preferred_Label ?Missing_Language {
  {
    SELECT DISTINCT ?Concept_IRI ?Default_Preferred_Label ?Missing_Language {
      ?project <https://grafsync.graphifi.com/schema/gs/projectLang> ?ML .
      BIND(IF(?ML = 'und', 'None', ?ML) AS ?Missing_Language)
      ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
      ?Concept_IRI a skos:Concept .
      ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Default_Preferred_Label .
      FILTER (LANG(?Default_Preferred_Label) = ?defaultLang || (LANG(?Default_Preferred_Label) = "" && ?defaultLang = "und"))      	
      FILTER NOT EXISTS {
        ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?PrefLabel .
        FILTER (LANG(?PrefLabel) = ?ML || (LANG(?PrefLabel) = "" && ?ML = "und"))      			
      }
    }
    ORDER BY ?Default_Preferred_Label ?ML
    LIMIT 100
  }
  OPTIONAL {
    ?Concept_IRI <https://grafsync.graphifi.com/schema/gs/iri> ?sIriList .
    ?sIriList <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest>* ?sIriListItem .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?Concept_New_IRI .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest> <http://www.w3.org/1999/02/22-rdf-syntax-ns#nil> .
  }
  BIND(IF(BOUND(?Concept_New_IRI), ?Concept_New_IRI, ?Concept_IRI) AS ?Concept)
}`
    },
    {
      "id": "preferredLabelLengths",
      "category": "Preferred Labels",
      "title": {
        "en": "Preferred Label Lengths"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "The distribution of preferred label lengths across the project in the default project language."
      },
      "barChart": ["Label_Length", "Concept_Count"],
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT DISTINCT ?Label_Length (COUNT(?concept) as ?Concept_Count) {
  GRAPH ?g {    
    ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
    ?concept a skos:Concept .
    ?concept (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Default_Preferred_Label .
    FILTER (LANG(?Default_Preferred_Label) = ?defaultLang || (LANG(?Default_Preferred_Label) = "" && ?defaultLang = "und"))
    BIND (STRLEN(STR(?Default_Preferred_Label)) AS ?Label_Length)
    
  }
}
GROUP BY ?Label_Length
ORDER BY ASC(?Label_Length)`
    },
    {
      "id": "unconnectedOntologyResources",
      "category": "Ontology Structure",
      "title": {
        "en": "Unconnected Resources"
      },
      "projectType": "OntologyProject",
      "description": {
        "en": "Classes and properties that do not have a 'parent' resource that is part of the same ontology, making them unconnected."
      },
      "query": `PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
SELECT ?Resource ?Resource_Type ?Label ?Ontology WHERE {
  ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
  {
    ?Resource a owl:Class .
    ?Resource (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    FILTER (!STRSTARTS(STR(?Resource), 'https://grafsync.graphifi.com/data/bn'))
    FILTER NOT EXISTS {
      ?Resource rdfs:subClassOf owl:Thing .
    }
    FILTER NOT EXISTS {
      ?Resource rdfs:subClassOf ?parent .
      FILTER (!STRSTARTS(STR(?parent), 'https://grafsync.graphifi.com/data/bn'))
      ?parent (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    }
    BIND ("Class" AS ?Resource_Type)
  }
  UNION
  {
    ?Resource a owl:ObjectProperty .
    ?Resource (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    FILTER NOT EXISTS {
      ?Resource rdfs:subPropertyOf owl:topObjectProperty .
    }
    FILTER NOT EXISTS {
      ?Resource rdfs:subPropertyOf ?parent .
      FILTER (!STRSTARTS(STR(?parent), 'https://grafsync.graphifi.com/data/bn'))
      ?parent (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    }
    BIND ("Object Property" AS ?Resource_Type)
  }
  UNION
  {
    ?Resource a owl:DatatypeProperty .
    ?Resource (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    FILTER NOT EXISTS {
      ?Resource rdfs:subPropertyOf owl:topDataProperty .
    }
    FILTER NOT EXISTS {
      ?Resource rdfs:subPropertyOf ?parent .
      FILTER (!STRSTARTS(STR(?parent), 'https://grafsync.graphifi.com/data/bn'))
      ?parent (rdfs:isDefinedBy | gs:visibility) ?Ontology .
    }
    BIND ("Datatype Property" AS ?Resource_Type)      
  }
  ?Resource rdfs:label ?Label
}
ORDER BY ?Resource ?Label LANG(?Label)
LIMIT 1000`
    },
    {
      "id": "labelLengths",
      "category": "Labels",
      "title": {
        "en": "Label Lengths"
      },
      "projectType": "OntologyProject",
      "description": {
        "en": "The distribution of label lengths across the project in the default project language (excluding named individuals and datatypes)."
      },
      "barChart": ["Label_Length", "Resource_Count"],
      "query": `PREFIX xowl: <https://graphifi.com/schema/xowl/>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT DISTINCT ?Label_Length (COUNT(?resource) as ?Resource_Count) {
  GRAPH ?g {    
    ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
    VALUES ?type {owl:Class owl:ObjectProperty owl:DatatypeProperty owl:AnnotationProperty}
    ?resource a ?type .
    FILTER (?resource NOT IN (owl:Thing, owl:topObjectProperty, owl:topDataProperty, xowl:topAnnotationProperty))
    FILTER (!STRSTARTS(STR(?resource), 'https://grafsync.graphifi.com/data/bn'))
    ?resource rdfs:label ?Label .
    FILTER (LANG(?Label) = ?defaultLang || (LANG(?Label) = "" && ?defaultLang = "und"))	
    BIND (STRLEN(STR(?Label)) AS ?Label_Length)    
  }
}
GROUP BY ?Label_Length
ORDER BY ASC(?Label_Length)`
    },
    {
      "id": "editCounts",
      "category": "Edits",
      "title": {
        "en": "Edit Counts"
      },
      "description": {
        "en": "List the number of recorded history edits over the past ten days for days that have had edits."
      },
      "barChart": ["Date", "Edit_Count"],
      "query": `SELECT DISTINCT ?Date (COUNT(?history) as ?Edit_Count) {
  GRAPH ?historyGraph {    
    ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?resource .
    ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
    BIND(STRDT(SUBSTR(STR(?changedTime), 0, 11), <http://www.w3.org/2001/XMLSchema#date>) AS ?Date)
  }
}
GROUP BY ?Date
ORDER BY DESC(?Date)
LIMIT 10`
    },
    {
      "id": "mostRecentlyEdited",
      "category": "Edits",
      "title": {
        "en": "Most Recently Edited Concepts"
      },
      "projectType": "TaxonomyProject",
      "description": {
        "en": "These are the most recently edited concepts from across the entire project."
      },
      "query": `PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT DISTINCT ?Concept ?Preferred_Label (MAX(?changedTime) as ?Last_Changed) {
{
  SELECT DISTINCT ?Concept_IRI {
    GRAPH  ?historyGraph {    
      ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?Concept_IRI .
      ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
      }
  }
  ORDER BY DESC(?changedTime)
  LIMIT 100
}
GRAPH  ?historyGraph {    
  ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?Concept_IRI .
  ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
}
GRAPH ?projectGraph {
  ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
  ?Concept_IRI a skos:Concept .
  ?Concept_IRI (skos:prefLabel | skosxl:prefLabel/skosxl:literalForm) ?Preferred_Label .
  FILTER (LANG(?Preferred_Label) = ?defaultLang)
  OPTIONAL {
    ?Concept_IRI <https://grafsync.graphifi.com/schema/gs/iri> ?sIriList .
    ?sIriList <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest>* ?sIriListItem .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?Concept_New_IRI .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest> <http://www.w3.org/1999/02/22-rdf-syntax-ns#nil> .
  }
  BIND(IF(BOUND(?Concept_New_IRI), ?Concept_New_IRI, ?Concept_IRI) AS ?Concept)
}
}
GROUP BY ?Concept ?Preferred_Label
ORDER BY DESC(MAX(?changedTime))
LIMIT 100
      `
    },
    {
      "id": "unapprovedResources",
      "category": "Workflow",
      "title": {
        "en": "Taxonomies with Unapproved Resources"
      },
      "projectType": "TaxonomyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Taxonomies with workflow activated and that have unapproved concepts or XL labels. (Deprecated resources are not included.)"
      },
      "barChart": ["Title", "Unapproved_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT * {
  {
    SELECT ?Title (COUNT(?resource) AS ?Unapproved_Count) ?Taxonomy WHERE {
      ?Taxonomy a skos:ConceptScheme .
      ?Taxonomy gs:activateWorkflow true .
      VALUES ?resourceType {skos:Concept skosxl:Label}
      ?resource a ?resourceType .
      ?resource skos:inScheme ?Taxonomy .
      FILTER NOT EXISTS {
        ?resource gs:status gs:accepted .
      }
      FILTER NOT EXISTS {
        ?resource gs:pendingDeletion true .
      }
      FILTER NOT EXISTS {
        ?resource owl:deprecated true .
      }
    }
    GROUP BY ?Taxonomy ?Title 
    ORDER BY DESC(?Unapproved_Count)
    LIMIT 100
  }
  OPTIONAL {
    ?project gs:defaultLang ?defaultLang .
    ?Taxonomy dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang || (LANG(?Title) = "" && ?defaultLang = "und"))
  }
}`
    },
    {
      "id": "withUnapprovedXL",
      "category": "Workflow",
      "title": {
        "en": "Approved Concepts with Unapproved XL Labels"
      },
      "projectType": "TaxonomyProject",
      "skosXL": true,
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Approved concepts in taxonomies with workflow activated and that have unapproved XL labels. (Deprecated resources are not included.)"
      },
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>

SELECT ?Default_Preferred_Label ?Concept ?Taxonomy WHERE {
  ?Taxonomy a skos:ConceptScheme .
  ?Taxonomy gs:activateWorkflow true .
  ?project gs:defaultLang ?defaultLang .
  ?Concept a skos:Concept .
  ?Concept skos:inScheme ?Taxonomy .
  ?Concept gs:status gs:accepted .
  ?Concept (skosxl:prefLabel | skosxl:altLabel | skosxl:hiddenLabel) ?xlLabel .
  FILTER NOT EXISTS {
    ?xlLabel gs:status gs:accepted .
  }
  FILTER NOT EXISTS {
    ?Concept gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?Concept owl:deprecated true .
  }
  ?Concept skosxl:prefLabel/skosxl:literalForm ?Default_Preferred_Label .
  FILTER (LANG(?Default_Preferred_Label) = ?defaultLang || (LANG(?Default_Preferred_Label) = "" && ?defaultLang = "und"))
}
ORDER BY ?Default_Preferred_Label
LIMIT 100`
    },
    {
      "id": "assignments",
      "category": "Workflow",
      "title": {
        "en": "Workflow Assignments"
      },
      "projectType": "TaxonomyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "The assignment of draft workflow tasks across project users."
      },
      "barChart": ["User", "Assignment_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX skosxl: <http://www.w3.org/2008/05/skos-xl#>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT ?User (COUNT(?resource) AS ?Assignment_Count) WHERE {
  ?resource gs:status <https://grafsync.graphifi.com/schema/gs/draft> .
  ?resource gs:assignedUser ?User .
  VALUES ?resourceType {skos:Concept skosxl:Label}
  ?resource a ?resourceType .
  ?resource skos:inScheme ?scheme .
  ?scheme gs:activateWorkflow true .
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?User
ORDER BY DESC(?Assignment_Count)`
    },
    {
      "id": "suggestions",
      "category": "Workflow",
      "title": {
        "en": "Taxonomies with Open Suggestions"
      },
      "projectType": "TaxonomyProject",
      "barChart": ["Title", "Count"],
      "description": {
        "en": "Taxonomies that have suggestions that have an open status."
      },
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>

SELECT DISTINCT ?Taxonomy ?Title (COUNT(?suggestion) AS ?Count) WHERE {
  ?Taxonomy a skos:ConceptScheme .
  ?project gs:defaultLang ?defaultLang .
  OPTIONAL {
    ?Taxonomy dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang)      	
  }
  ?suggestion <https://grafsync.graphifi.com/schema/vm/suggestionSourceConcept> ?source .
  ?suggestion gs:status gs:pending .
  ?suggestion skos:inScheme ?Taxonomy .
  FILTER NOT EXISTS {
    ?source gs:pendingDeletion true .
  }
}
GROUP BY ?Taxonomy ?Title
ORDER BY DESC(?Count) ?Title
LIMIT 100`
    },
    {
      "id": "unapprovedResourcesData",
      "category": "Workflow",
      "title": {
        "en": "Datasets with Unapproved Resources"
      },
      "projectType": "DataProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Datasets with workflow activated and that have unapproved resources. (Deprecated resources are not included.)"
      },
      "barChart": ["Title", "Unapproved_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT ?Title (COUNT(?resource) AS ?Unapproved_Count) ?Dataset WHERE {
  ?Dataset a gs:Dataset .
  ?Dataset gs:activateWorkflow true .
  ?project gs:defaultLang ?defaultLang .
  OPTIONAL {
    ?Dataset dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang || (LANG(?Title) = "" && ?defaultLang = "und"))
  }
  ?resource gs:inDataset ?Dataset .
  FILTER NOT EXISTS {
    ?resource gs:status gs:accepted .
  }
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?Dataset ?Title 
ORDER BY DESC(?Unapproved_Count)
LIMIT 100`
    },
    {
      "id": "assignmentsData",
      "category": "Workflow",
      "title": {
        "en": "Workflow Assignments"
      },
      "projectType": "DataProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "The assignment of draft workflow tasks across project users."
      },
      "barChart": ["User", "Assignment_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>PREFIX owl: <http://www.w3.org/2002/07/owl#>

SELECT ?User (COUNT(?resource) AS ?Assignment_Count) WHERE {
  ?resource gs:status <https://grafsync.graphifi.com/schema/gs/draft> .
  ?resource a gs:Resource .
  ?resource gs:assignedUser ?User .
  ?resource gs:inDataset ?dataset .
  ?dataset gs:activateWorkflow true .
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?User
ORDER BY DESC(?Assignment_Count)`
    },
    {
      "id": "mostRecentlyEditedData",
      "category": "Edits",
      "title": {
        "en": "Most Recently Edited Resources"
      },
      "projectType": "DataProject",
      "description": {
        "en": "These are the most recently edited resources from across the entire project."
      },
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>

SELECT DISTINCT ?Resource ?Label (MAX(?changedTime) as ?Last_Changed) {
{
  SELECT DISTINCT ?Resource_IRI {
    GRAPH  ?historyGraph {    
      ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?Resource_IRI .
      ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
      }
  }
  ORDER BY DESC(?changedTime)
  LIMIT 100
}
GRAPH  ?historyGraph {    
  ?history <https://grafsync.graphifi.com/schema/gs/isHistoryOf> ?Resource_IRI .
  ?history <https://grafsync.graphifi.com/schema/gs/changedTime> ?changedTime .
}
GRAPH ?projectGraph {
  ?project <https://grafsync.graphifi.com/schema/gs/defaultLang> ?defaultLang .
  ?Resource_IRI a gs:Resource .
  ?Resource_IRI rdfs:label ?Label .
  FILTER (LANG(?Label) = ?defaultLang || (LANG(?Label) = "" && ?defaultLang = "und"))
  OPTIONAL {
    ?Resource_IRI <https://grafsync.graphifi.com/schema/gs/iri> ?sIriList .
    ?sIriList <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest>* ?sIriListItem .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?Resource_New_IRI .
    ?sIriListItem <http://www.w3.org/1999/02/22-rdf-syntax-ns#rest> <http://www.w3.org/1999/02/22-rdf-syntax-ns#nil> .
  }
  BIND(IF(BOUND(?Resource_New_IRI), ?Resource_New_IRI, ?Resource_IRI) AS ?Resource)
}
}
GROUP BY ?Resource ?Label
ORDER BY DESC(MAX(?changedTime))
LIMIT 100
      `
    },
        {
      "id": "unapprovedResourcesOntology",
      "category": "Workflow",
      "title": {
        "en": "Ontologies with Unapproved Resources"
      },
      "projectType": "OntologyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "Ontologies with workflow activated and that have unapproved resources. (Deprecated resources are not included.)"
      },
      "barChart": ["Title", "Unapproved_Count"],
      "query": `PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX dct: <http://purl.org/dc/terms/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>

SELECT ?Title (COUNT(DISTINCT ?resource) AS ?Unapproved_Count) ?Ontology WHERE {
  ?Ontology a owl:Ontology .
  ?Ontology gs:activateWorkflow true .
  ?project gs:defaultLang ?defaultLang .
  OPTIONAL {
    ?Ontology dct:title ?Title .
    FILTER (LANG(?Title) = ?defaultLang || (LANG(?Title) = "" && ?defaultLang = "und"))
  }
  ?resource (rdfs:isDefinedBy | gs:visibility) ?Ontology .
  FILTER (!STRSTARTS(STR(?resource), 'https://grafsync.graphifi.com/data/bn'))
  FILTER NOT EXISTS {
    ?resource gs:status gs:accepted .
  }
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?Ontology ?Title 
ORDER BY DESC(?Unapproved_Count)
LIMIT 100`
    },
    {
      "id": "assignmentsData",
      "category": "Workflow",
      "title": {
        "en": "Workflow Assignments"
      },
      "projectType": "OntologyProject",
      "subscriptionType": ["Trial", "Managed", "Premium"],
      "description": {
        "en": "The assignment of draft workflow tasks across project users."
      },
      "barChart": ["User", "Assignment_Count"],
      "query": `
PREFIX gs: <https://grafsync.graphifi.com/schema/gs/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>

SELECT ?User (COUNT(DISTINCT ?resource) AS ?Assignment_Count) WHERE {
  ?resource gs:assignedUser ?User .
  ?resource (rdfs:isDefinedBy | gs:visibility) ?ontology .
  FILTER (!STRSTARTS(STR(?resource), 'https://grafsync.graphifi.com/data/bn'))
  ?ontology gs:activateWorkflow true .
  ?resource gs:status <https://grafsync.graphifi.com/schema/gs/draft> .
  FILTER NOT EXISTS {
    ?resource gs:pendingDeletion true .
  }
  FILTER NOT EXISTS {
    ?resource owl:deprecated true .
  }
}
GROUP BY ?User
ORDER BY DESC(?Assignment_Count)`
    }
  ];
}